import React, { useEffect, useState, useCallback } from "react";
import { TopBar } from "./TopBar";
import * as Mui from "@mui/material";
import { themes } from "services/constants";
import { BasicInfo } from "./BasicInfo";
import { customGetAPI } from "services/utils/CustomAPI";
import { useDispatch, useSelector } from "react-redux";
import { PersonalInfo } from "./PersonalInfo";
import { EmployeeSalaryInfo } from "pages/HR/EmployeeOnboard/CreateUserEmployee/EmployeeSalaryInfo";
import { Loader } from "components/Loader";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { setEditPage } from "services/Redux/HRPortal";

export const EditEmployee = () => {
  const requestCompanyId = useSelector((state) => state.tokenReducer.topbarCompanyId);
  const history = useHistory();
  const dispatch = useDispatch();
  const params = useParams();
  const { domain } = useSelector((state) => state.tokenReducer);
  const { pageno, userid } = useSelector((state) => state.hrportal);
  // URL params are the source of truth when present (deep-linked entry).
  // The ExistingUser "add more data" flow doesn't carry a URL param, so it
  // falls back to the Redux values it dispatches before navigating here.
  const initialUserId = params.userId || userid;
  const [getEmployeeDetails, seyGetEmployeeDetails] = useState(true);
  const [userId, setUserId] = useState(initialUserId);
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [updateUserDetails, setUpdateUserDetails] = useState(true);
  const [loader, setLoader] = useState(false);
  const [isFieldFilled, setIsFieldFilled] = useState(false);

  useEffect(() => {
    if (params.pageno) {
      dispatch(setEditPage(Number(params.pageno)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFieldCheck = (filled) => {
    setIsFieldFilled(filled);
  };

  const getSelectedUserDetails = useCallback(
    async (id) => {
      setLoader(true);
      const res = await customGetAPI(`${domain}employee/details?user_id=${id}&company_id=${requestCompanyId}`);
      if (res.ok) {
        setEmployeeDetails(res.responseDetails);
        setUpdateUserDetails(true);
        setLoader(false);
      } else {
        setLoader(false);
      }
    },
    [domain, requestCompanyId]
  );

  useEffect(() => {
    if (getEmployeeDetails) {
      getSelectedUserDetails(userId);
      // localStorage.setItem("editEmployeeIdNumber", null);
      // localStorage.setItem("editEmployeeDetails", false);
      seyGetEmployeeDetails(false);
    }
  }, [getEmployeeDetails, getSelectedUserDetails, userId]);

  const renderComponent = () => {
    switch (pageno) {
      case 1:
        return (
          <BasicInfo
            pageno={pageno}
            employeeDetails={employeeDetails}
            getSelectedUserDetails={getSelectedUserDetails}
            setUpdateUserDetails={setUpdateUserDetails}
            updateUserDetails={updateUserDetails}
            setUserId={setUserId}
            loader={loader}
            onFieldCheck={handleFieldCheck}
          />
        );
      case 2:
        return (
          <PersonalInfo
            pageno={pageno}
            employeeDetails={employeeDetails}
            getSelectedUserDetails={getSelectedUserDetails}
            setUpdateUserDetails={setUpdateUserDetails}
            updateUserDetails={updateUserDetails}
            setUserId={setUserId}
            onFieldCheck={handleFieldCheck}
          />
        );
      case 3:
        return (
          <EmployeeSalaryInfo
            isEditScreen={true}
            getCompanyId={employeeDetails?.company_id}
            isSalaryTemplateUpdate={
              employeeDetails?.salary_template_data != null
            }
            onClose={() => history.push("/admin/hrzone/employees")}
            reCallApi={() => getSelectedUserDetails(userId)}
          />
        );
      default:
        break;
    }
  };

  return loader ? (
    <Loader info="Loading..." />
  ) : (
    <React.Fragment>
      <Mui.Grid container sx={{ paddingTop: 2 }}></Mui.Grid>
      <Mui.Grid container>
        <TopBar
          pageno={pageno}
          employeeDetails={employeeDetails}
          setUpdateUserDetails={setUpdateUserDetails}
          isFieldFilled={isFieldFilled}
        />
      </Mui.Grid>
      <Mui.Grid
        container
        sx={{
          padding: 2,
          width: "99.5%",
          height: "100%",
          borderRadius: 5,
          border: `5px solid ${themes.sidebarDivider}`,
        }}
      >
        <Mui.Grid container>{renderComponent()}</Mui.Grid>
      </Mui.Grid>
    </React.Fragment>
  );
};
